<template>
  <v-row v-if="loading && loadingLocal">
    <v-col cols="6">
      <v-skeleton-loader type="text" />
    </v-col>
    <v-col cols="6">
      <v-skeleton-loader type="text" />
    </v-col>
  </v-row>
  <v-row v-else>
    <span class="text-uppercase mb-6 pl-4" v-if="enturmacoes.length">
      {{
        `${inscricaoLocal.matricula.pessoa.nome} ENTURMADO NA TURMA
              ${enturmacoes[0].turma.nomeCompleto} - ${enturmacoes[0].turma.unidadeEnsino.nomeCompleto}`
      }}
    </span>

    <v-col
      v-if="inscricaoLocal.matricula.status !== 'CURSANDO' && !loading"
      class="mb-4"
    >
      O STATUS DESTA MATRÍCULA É
      <strong>{{ inscricaoLocal.matricula.status }}</strong>
    </v-col>

    <template v-if="!loading && (transferindoAluno || deferindoAluno)">
      <v-col cols="6" class="pb-0 mb-0">
        <CPTAutocomplete
          v-model="unidadeEnsinoLocal"
          :disabled="loading"
          :items="unidadesEnsino"
          itemText="nomeCompleto"
          label="Unidade de Ensino de Destino"
          noDataText="Nenhuma unidade encontrada"
          return-object
          @change="getTurmas"
        />
      </v-col>
      <v-col cols="6" class="pb-0 mb-0">
        <CPTAutocomplete
          v-model="turmaLocal"
          :disabled="!unidadeEnsinoLocal || loadingLocal"
          :error-messages="turmaErrorState"
          :hint="hintTurma"
          :items="turmas"
          :loading="loadingLocal"
          :rules="rulesTurma"
          itemText="nomeCompleto"
          label="Turma"
          noDataText="Nenhuma turma encontrada"
          return-object
        />
      </v-col>
    </template>
  </v-row>
</template>

<script>
import CPTAutocomplete from "@/components/Autocomplete";

export default {
  name: "quinta-secao-unidade-ensino",

  components: {
    CPTAutocomplete,
  },

  props: {
    value: {
      type: Object,
      required: true,
    },
    alunoEnturmado: {
      type: Boolean,
      required: true,
    },
    turma: {
      type: Object,
      default: () => ({}),
    },
    unidadeEnsino: {
      type: Object,
      default: () => {},
    },
    enturmacoes: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    transferindoAluno: {
      type: Boolean,
      default: false,
    },
    deferindoAluno: {
      type: Boolean,
      default: false,
    },
    unidadesEnsino: {
      type: Array,
      default: () => [],
    },
  },

  data: () => ({
    transferencias: [],
    turmas: [],
    loadingLocal: false,
  }),

  computed: {
    inscricaoLocal: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
    turmaLocal: {
      get() {
        return this.turma;
      },
      set(turma) {
        this.$emit("update:turma", turma);
      },
    },
    unidadeEnsinoLocal: {
      get() {
        return this.unidadeEnsino;
      },
      set(unidadeEnsino) {
        this.$emit("update:unidadeEnsino", unidadeEnsino);
      },
    },
    turmaErrorState() {
      if (this.turma && this?.turma.id === this?.enturmacoes[0]?.turma?.id) {
        return "Aluno já está enturmado nesta turma";
      }
      if (
        this.turma &&
        this?.turma?.etapa?.ordem < this?.enturmacoes[0]?.turma?.etapa.ordem
      ) {
        return `Aluno matrículado em turma do ${this?.enturmacoes[0]?.turma?.etapa.nome}`;
      }
      return "";
    },

    hintTurma() {
      if (this.turma) {
        // quantidade de alunos + transferencias VIN pendentes
        return `${this.turma.quantidadeAlunos + this.transferencias.length}/${
          this.turma.limiteAlunos
        }`;
      }
      return "";
    },

    rulesTurma() {
      return [
        () =>
          this.turmaLocal &&
          // quantidade de alunos + transferencias VIN pendentes
          this.turma.quantidadeAlunos + this.transferencias.length >=
            this.turmaLocal.limiteAlunos
            ? "Nenhuma vaga disponível nesta turma"
            : true,
      ];
    },
  },

  methods: {
    async getTurmas() {
      if (!this.unidadeEnsinoLocal?.id) return;

      this.turmaLocal = null;
      this.loadingLocal = true;

      await this.$erudio
        .get("turmas", {
          params: {
            unidadeEnsino: this.unidadeEnsinoLocal?.id,
            apelido: "VIN",
            view: "DETAILS",
          },
        })
        .then((turmas) => {
          this.turmas = turmas;
          this.getTransferencias();
        })
        .catch((error) => {
          this.loadingLocal = false;
          this.showMessage(error, "error");
        });
    },

    async getTransferencias() {
      if (!this.unidadeEnsinoLocal?.id) return;

      await this.$erudio
        .get("transferencias", {
          params: {
            unidadeEnsinoDestino: this.unidadeEnsinoLocal?.id,
            encerrado: 0,
          },
        })
        .then((transferencias) => {
          this.transferencias = transferencias.filter(
            (t) => t.justificativa === "DEFERIDO NO CADASTRO DE VAGA INTEGRAL"
          );

          this.loadingLocal = false;
        })
        .catch((error) => {
          this.loadingLocal = false;
          this.showMessage(error, "error");
        });
    },
  },

  watch: {
    unidadeEnsinoLocal() {
      setTimeout(() => {
        // Paliativo (Erro de responsividade - Carrega as Turmas ANTES de alterar o ID da unidade de ensino)
        this.getTurmas();
      }, 100);
    },
  },
};
</script>
